// Dropdown: Tag List Tag
// 

JLM.MD.DropdownTagsTag = function( container, data_label, data_value ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	let item;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.label = data_label;
	INSTANCE.value = data_value;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let label, icon;
		item = $('<li data-value="' + INSTANCE.value + '" />').appendTo( container );
		label = $('<span class="label">' + INSTANCE.label + '</span>').appendTo( item );
		icon = $('<span class="icon"><svg><use xlink:href="#jl_icon_cross"></use></svg></span>').appendTo( item );
		
		// Events
		icon.on('click', removeTag);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Internal remove (bubble change)
	// 
	function removeTag() {
		INSTANCE.dispatchEvent('remove', [ INSTANCE.value ]);
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Remove tag
	INSTANCE.remove = function() {
		item.remove();
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};